import React from "react";
import { ArrowRight } from "lucide-react";
import "./BookmakerBanner.css";

const BookmakerBanner = ({
  namePart1 = "",
  namePart1Color = "#ffffff",
  namePart2 = "",
  namePart2Color = "#ffffff",
  offer = "Free Bet",
  bgColor = "#000",
  textColor= "#000",
  url = "#",
}) => {
  return (
    <div className="bookmaker-banner" style={{ backgroundColor: bgColor }}>
      <div className="bookmaker-banner__name">
        <span
          className="bookmaker-banner__name-part1"
          style={{ color: namePart1Color }}
        >
          {namePart1}
        </span>
        <span
          className="bookmaker-banner__name-part2"
          style={{ color: namePart2Color }}
        >
          {namePart2}
        </span>
      </div>
      <div className="bookmaker-banner__offer-container">
        <div className="bookmaker-banner__offer" style={{ color: textColor }}>{offer}</div>
        <a href={url} className="bookmaker-banner__button" target="_blank" rel="noreferrer">
          <ArrowRight size={20} />
        </a>
      </div>
    </div>
  );
};

export default BookmakerBanner;
